var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mt-4"},[_c('h3',[_vm._v("Lesson Schedules")]),_c('v-data-table',{staticClass:"mt-2",attrs:{"headers":_vm.headers,"items":_vm.lessons},on:{"click:row":_vm.showLesson}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }